import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntryByTitle} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

/**
 * Hook to fetch all footer entries from contentstack
 */
export const useGetSovraHeader = () => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getPreHeaderRes = async () => {
        const response = await getEntryByTitle({
            stack,
            contentTypeUid: 'pre_header',
            title: 'preheader',
            locale: locale.alias,
        })
        return response[0]
    }

    return useQuery(['contentstackGetPreHeader', 'preHeader'], () => getPreHeaderRes())
}
